import script from "./personalContentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./personalContentEdit.vue?vue&type=script&setup=true&lang=js"

import "./personalContentEdit.vue?vue&type=style&index=0&id=76e059fe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e059fe"]])

export default __exports__